export default [
  {
    path: 'afiliados/pixel',
    name: 'pixel',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Pixel',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Afiliados', link: 'afiliados' },
        { name: 'Pixel' },
      ]
    }
  },
]